import React, { useCallback, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Form } from '@unform/web'
import { Alert } from '@vtex/shoreline'
import PropTypes from 'prop-types'

import { Button } from '~/components/Buttons'
import ExpandableSection from '~/components/ExpandableSection'
import AddressFields from '~/pages/locations/_elements/FormLocation/Address'
import { updateCustomer } from '~/store/modules/customers/actions'

import * as S from './styles'

const CustomerAddressForm = ({ onCancelEditMode, isEditMode }) => {
  const formRef = useRef(null)

  const dispatch = useDispatch()

  const { saveCustomersLoading: loading, customer } = useSelector(
    state => state.customers
  )

  const handleSubmit = useCallback(
    formData => {
      const body = { ...customer, ...formData, address_country: 'Brazil' }

      if (isEditMode) {
        dispatch(updateCustomer({ body, onSuccess: onCancelEditMode }))
        return
      }

      dispatch(updateCustomer({ body }))
    },
    [customer, dispatch, isEditMode, onCancelEditMode]
  )

  return (
    <S.FormAddress>
      {!isEditMode && (
        <Alert variant="warning">
          O endereço do cliente está incompleto. Você pode completar o endereço
          abaixo.
        </Alert>
      )}

      {isEditMode && (
        <header>
          <Button
            type="button"
            text="Cancelar edição"
            textLoading="Salvando..."
            loading={loading}
            disabled={loading}
            size="xsmall"
            template="transparentCritical"
            customWidth="100%"
            onClick={onCancelEditMode}
          />
        </header>
      )}

      <Form onSubmit={handleSubmit} initialData={customer} ref={formRef}>
        <ExpandableSection>
          <AddressFields
            formRef={formRef}
            labelItem="do cliente"
            hideCoordinates
            allRequired
          />

          <div className="form-default__buttons">
            {isEditMode && (
              <Button
                type="button"
                text="Cancelar"
                textLoading="Salvando..."
                loading={loading}
                disabled={loading}
                size="small"
                template="transparentCritical"
                customWidth="auto"
                onClick={onCancelEditMode}
              />
            )}

            <Button
              type="submit"
              text="Salvar"
              textLoading="Salvando..."
              loading={loading}
              disabled={loading}
              size="small"
              template="primary"
              customWidth="auto"
            />
          </div>
        </ExpandableSection>
      </Form>
    </S.FormAddress>
  )
}

export default CustomerAddressForm

CustomerAddressForm.propTypes = {
  onCancelEditMode: PropTypes.func,
  isEditMode: PropTypes.bool
}

CustomerAddressForm.defaultProps = {
  onCancelEditMode: null,
  isEditMode: false
}
